import React from 'react'
import PropTypes from 'prop-types'
import { Switch, FormControlLabel } from '@material-ui/core'
import styled from 'styled-components/macro'

const Container = styled.fieldset`
  display: flex;
  align-items: center;
`

const Label = styled.label`
  color: ${({ theme }) => theme.colors.textTonedDown};
`

const CustomFormControlLabel = styled(FormControlLabel)`
  margin-left: 0 !important;
  margin-right: 0 !important;
`

const StyledSwitch = styled(Switch)`
  /* Overwriting default track color */
  .MuiSwitch-track {
    opacity: 1 !important;

    /* Apply color to the track only when the toggle is checked */
    background-color: ${({ theme, $isToggleChecked, $trackColor }) =>
      $isToggleChecked
        ? theme.colors.toggleTrackColor || $trackColor
        : theme.colors.brandCharlie} !important;
  }

  /* Overwriting default thumb color when checked */
  .MuiSwitch-colorPrimary.Mui-checked {
    color: white !important;
  }
`

const ToggleSwitch = ({
  checked,
  onChange,
  labelLeft,
  labelRight,
  trackColor,
  id = 'toggle-switch',
  ...props
}) => {
  return (
    <Container>
      {labelLeft && <Label htmlFor={id}>{labelLeft}</Label>}
      <CustomFormControlLabel
        control={
          <StyledSwitch
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            color="primary"
            $isToggleChecked={checked}
            $trackColor={trackColor}
            {...props}
          />
        }
      />
      {labelRight && <Label htmlFor={id}>{labelRight}</Label>}
    </Container>
  )
}

ToggleSwitch.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  labelLeft: PropTypes.string,
  labelRight: PropTypes.string,
  trackColor: PropTypes.string,
  id: PropTypes.string,
}

export default ToggleSwitch
